import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'RECHERC_CLIENT',
  title: 'Wie suche ich nach einem Kunden in meiner Liste?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie auf die Registerkarte "Kunden".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_RECHERC_CLIENT/DE_RECHERC_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Suchen Sie in der Suchleiste nach Ihren Kunden.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_RECHERC_CLIENT/DE_RECHERC_CLIENT_2.png`
  }]
};
